import styled from "styled-components"

export const RankingStar = styled.div`
  position: absolute;
  left: -3rem;
  width: 34px;
  height: 34px;
  

  &::before {
    content: "${({ index }) => index}";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    font-weight: bold;
    z-index: 999;
    color: ${({ index }) => {
      if (index === 1) return "#FFF"
      if (index === 2) return "#000"
      if (index === 3) return "#FFF"
      return "#000"
    }};
    
  
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ index }) => {
      if (index === 1) return "#ffd700"
      if (index === 2) return "#c0c0c0"
      if (index === 3) return "#cd7f32"
      return "#fff"
    }};
   
    
    }

    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  }
`
